module.exports = __webpack_public_path__ + "static/media/lobster.e0b89e6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Shop/assets/screenshots/landing/lobster.png
// module id = 836
// module chunks = 20